import { t, Trans } from "@lingui/macro";

import { userAnalytics } from "lib/userAnalytics";
import { LandingPageAgreementConfirmationEvent } from "lib/userAnalytics/types";
import { useRedirectPopupTimestamp } from "lib/useRedirectPopupTimestamp";

import Button from "components/Button/Button";
import ExternalLink from "components/ExternalLink/ExternalLink";

import Checkbox from "../Checkbox/Checkbox";
import Modal from "../Modal/Modal";
import "./RedirectModal.css";

export function RedirectPopupModal({
  redirectModalVisible,
  setRedirectModalVisible,
  appRedirectUrl,
  setShouldHideRedirectModal,
  shouldHideRedirectModal,
}: {
  redirectModalVisible: boolean;
  setRedirectModalVisible: (visible: boolean) => void;
  appRedirectUrl: string;
  setShouldHideRedirectModal: (value: boolean) => void;
  shouldHideRedirectModal: boolean;
}) {
  const [, setRedirectPopupTimestamp] = useRedirectPopupTimestamp();
  const onClickAgree = () => {
    userAnalytics.pushEvent<LandingPageAgreementConfirmationEvent>({
      event: "LandingPageAction",
      data: {
        action: "AgreementConfirmationAgreeClick",
      },
    });

    if (shouldHideRedirectModal) {
      setRedirectPopupTimestamp(Date.now());
    }
  };

  return (
    <Modal
      className="RedirectModal"
      isVisible={redirectModalVisible}
      setIsVisible={setRedirectModalVisible}
      label={t`Launch app`}
    >
      <Trans>Leaving GMX.io for a third-party website</Trans>
      <br />
      <br />
      <Trans>
        The website is a community-deployed instance of the open source{" "}
        <ExternalLink href="https://github.com/gmx-io/gmx-interface">GMX front end</ExternalLink>, hosted on the
        distributed, peer-to-peer <ExternalLink href="https://ipfs.io/">IPFS network</ExternalLink>
      </Trans>
      <br />
      <br />
      <Trans>
        Alternative links are in the{" "}
        <ExternalLink href="https://docs.gmx.io/docs/api/frontend-integration/">docs</ExternalLink>.
        <br />
        <br />
        By clicking Agree, you accept the <ExternalLink href="https://gmx.io/#/terms-and-conditions">
          T&Cs
        </ExternalLink>{" "}
        and <ExternalLink href="https://gmx.io/#/referral-terms">Referral T&Cs</ExternalLink>.
        <br />
        <br />
      </Trans>
      <div className="mb-15">
        <Checkbox isChecked={shouldHideRedirectModal} setIsChecked={setShouldHideRedirectModal}>
          <Trans>Don't show for 30 days</Trans>
        </Checkbox>
      </div>
      <Button variant="primary-action" className="w-full" to={appRedirectUrl} onClick={onClickAgree}>
        <Trans>Agree</Trans>
      </Button>
    </Modal>
  );
}
